import { Card } from "@f2e/ui/components/base"
import { LineClientConfig } from "@/types"
import { LineConnectionData, LineConnectionForm } from "../line"

export interface LineConfigFieldsProps {
  config: LineClientConfig
  isEditing: boolean
  channelId: string
  workspaceId: string
  organizationId: string
  onConfigChange?: (config: Partial<LineClientConfig>) => void
  onSave?: (config: LineClientConfig) => void
  isLoading?: boolean
  onDirtyChange?: (isDirty: boolean) => void
}

export const LineConfigFields = ({
  config,
  channelId,
  workspaceId,
  organizationId,
  onConfigChange,
  onSave,
  isLoading = false,
  onDirtyChange,
}: LineConfigFieldsProps) => {
  const handleLineSubmit = (data: LineConnectionData) => {
    const updatedConfig: LineClientConfig = {
      ...config,
      channelSecret: data.channelSecret,
      channelAccessToken: data.channelAccessToken,
      liffId: data.liffId,
      lineLoginChannelId: data.lineLoginChannelId,
      agentId: data.agentId,
      requireEmailVerification: data.requireEmailVerification,
      skipKeywords: data.skipKeywords,
      conversationSessionTimeoutHours: data.conversationSessionTimeoutHours,
    }
    onConfigChange?.(updatedConfig)
    onSave?.(updatedConfig)
  }

  return (
    <Card className="p-6">
      <LineConnectionForm
        channelId={channelId}
        workspaceId={workspaceId}
        organizationId={organizationId}
        initialData={{
          channelSecret: config.channelSecret,
          channelAccessToken: config.channelAccessToken,
          liffId: config.liffId,
          lineLoginChannelId: config.lineLoginChannelId,
          agentId: config.agentId,
          requireEmailVerification: config.requireEmailVerification,
          skipKeywords: config.skipKeywords,
          conversationSessionTimeoutHours:
            config.conversationSessionTimeoutHours,
        }}
        onSubmit={handleLineSubmit}
        isLoading={isLoading}
        onDirtyChange={onDirtyChange}
      />
    </Card>
  )
}

export default LineConfigFields
